<template>
  <mounting-portal mount-to="#modal-wrapper" append>
    <transition name="slide-left">
      <div
        v-if="visible"
        class="page-info d-flex flex-column align-items-center"
      >
        <BaseHeader
          :title="title"
          :is-title-bold="true"
          :left-arrow="true"
          :back-on-click-left="false"
          @on-click-left="$emit('close')"
        ></BaseHeader>
        <div class="content h-100 w-100 p-3 scroll-bar">
          <slot></slot>
        </div>
      </div>
    </transition>
  </mounting-portal>
</template>

<script>
import BaseHeader from '@/components/Base/BaseHeader';

export default {
  components: {
    BaseHeader,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '資訊說明',
    },
    content: {
      type: String,
      default: '',
    },
    hasButton: {
      type: Boolean,
      default: true,
    },
    hideFooter: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
      default: '知道了',
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.page-info {
  padding: env(safe-area-inset-top) 0 env(safe-area-inset-bottom) 0;
}
.page-info {
  width: 100vw;
  height: 100vh;
  overflow: overlay;
  top: 0;
  z-index: 9999;
  position: absolute;
  background: $bgcontainer;
  .content {
    overflow: overlay;
  }
}
// SLIDE_TRANSITION
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-left-leave-active,
.slide-right-enter {
  transform: translate(100vw, 0);
}
.slide-left-leave-to {
  animation: none;
}
</style>
